import { useEffect, useState } from 'react';

/** Returns true only after `value` stays true for `delayMs`. Resets when `value` or `resetKey` changes. */
export function useDelayedTrue(
  value: boolean,
  delayMs: number,
  resetKey?: string | null,
): boolean {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!value) {
      setShow(false);
      return;
    }

    setShow(false);
    const timer = window.setTimeout(() => {
      setShow(true);
    }, delayMs);

    return () => {
      window.clearTimeout(timer);
    };
  }, [value, delayMs, resetKey]);

  return show;
}
